import apiServiceCall from "../services/ApiServiceCall";

export const getMetricsData = async (citizenID) => {
    try {
        const statsRes = await apiServiceCall().get(`/statistics/${citizenID}`).then(({ data }) => data).catch(() => null);

        return {
            reqsOpen: statsRes?.reqsOpen || 0,
            reqsComplete: statsRes?.reqsComplete || 0,
            reqsRejected: statsRes?.reqsRejected || 0,
            documents: statsRes?.documents || 0
        };
    } catch (error) {
        console.error("Error fetching metrics data:", error);
        return { reqsOpen: 0, reqsComplete: 0, reqsRejected: 0, documents: 0 };
    }
};
